export default {
  RemoveItem: 'اقلام حذف شد',
  RemoveSize: 'اندازه حذف شد',
  RemoveEmployee: 'فرد حذف شد',
  RemovColor: 'رنگ حذف شد',
  NewEmployeeAdd: 'فرد جدید اضافه شد',
  NewItemsAdd: 'اقلام جدید اضافه شد',
  NewColorAdd: 'رنگ جدید اضافه شد',
  FeaturSizeUpdate: ' اندازه بروزرسانی شد ',
  FeaturItemUpdate: 'اقلام بروزرسانی شد',
  FeaturColorUpdate: 'رنگ ها بروزرسانی شد',
  FeaturEmployeeUpdate: 'فرد بروزرسانی شد',
  NewSizeAdd: 'اندازه جدید اضافه شد',
  NewFeedbackCriterionAdd: 'معیار بازخورد جدید اضافه کنید',

  Item: 'اقلام',
  Colors: 'رنگ ها',
  Color: 'رنگ',
  colorCode: 'کد رنگ',
  ColorName: 'اسم رنگ',
  Size: 'اندازه',
  Description: 'شرح',
  Employee: 'افراد',
  Order: 'ترتیب',
  Opacity: 'شفافیت',
  Enable: 'فعال',
  Disable: 'غیرفعال',
  Image: 'عکس',
  Slug: 'Slug',
  rgbCode: 'کد رنگ(RGB)'
}
